import React, { useContext, useState } from 'react'
import { styled } from '@mui/material/styles';
import Add from '@mui/icons-material/Add';
import Remove from '@mui/icons-material/Remove';
import MuiAccordion from '@mui/material/Accordion';
import MuiAccordionSummary from '@mui/material/AccordionSummary';
import MuiAccordionDetails from '@mui/material/AccordionDetails';
import Typography from '@mui/material/Typography';
import { LanguageContext } from '../context';

const Accordion = styled((props) => (
  <MuiAccordion disableGutters elevation={0}  {...props} />
))(() => ({
  borderBottom: `0`,
  background: 'none',
  '&::before': {
    display: 'none',
  },
}));

const AccordionSummary = styled((props) => (
  <MuiAccordionSummary
    expandIcon={props.expanded ? <Remove sx={{ fontSize: '2rem', color: '#3C2E77' }} /> : <Add sx={{ fontSize: '2rem', color: '#3C2E77' }} />}
    {...props}
  />
))(({ theme }) => ({
  background: 'none',
  fontSize: '21px',
  fontWeight: 'bold',
  borderBottom: `1px solid #3C2E77`,
  color: '#3C2E77',
  flexDirection: 'row',
  '& .MuiAccordionSummary-expandIconWrapper.Mui-expanded': {
    transform: 'rotate(0deg)',
  },
  '& .MuiAccordionSummary-content': {
    marginRight: theme.spacing(1),
  }
}));

const AccordionDetails = styled(MuiAccordionDetails)(() => ({
  fontSize: '1rem',
  textAlign: 'left',
  padding: '1rem',
  color: '#3C2E77',
  borderTop: '1px solid #3C2E77',
}));

const faqData = [
  {
    question: "Dois-je créer un compte pour utiliser WeCar ?",
    answer: "Il est nécessaire de créer un compte sécurisé avant de créer un covoiturage, de proposer une voiture ou de rechercher une place. Cela rend l’utilisation de la plateforme plus sécurisée."
  },
  {
    question: "Comment retrouver, modifier ou supprimer un covoiturage, un conducteur ou un passager?",
    answer: "Connectez-vous à l’aide de votre adresse email en cliquant sur « S’identifier » en haut à droite de l’écran. En cliquant sur mes covoiturages, vous accéderez à la page reprenant les covoiturages vous concernant. Si vous en êtes le créateur, une icône « éditer » apparaîtra. Si vous êtes conducteurs ou passagers, des boutons « Modifier » et « Supprimer » seront disponibles."
  },
  {
    question: "Comment contacter un conducteur ou un passager?",
    answer: "Tout d’abord il faut s’identifier. Si le conducteur a partagé son numéro de téléphone ou email, vous pouvez le voir en cliquant sur l’icône “voir les détails” en dessus de la voiture proposée. En tant que conducteur vous pouvez également contacter les passagers en allant sur l’icône “crayon” à côté de votre voiture, vous aurez les numéros de téléphone et email des passagers mais aussi une possibilité d’envoyer un message commun à vos passagers via l’icône “envoyer un message à tous les passagers”."
  },
  {
    question: "Si j'ai trouvé une voiture, puis-je être sûr de partir avec ce conducteur ?",
    answer: "Oui. Si la situation l’exige, le conducteur peut se faire remplacer uniquement par une personne qu’il juge adéquate selon les circonstances, et qui respecte également les présentes Conditions ainsi que toute autre règle édictée par WeCar."
  },
  {
    question: "Comment faire si nous sommes deux passagers ?",
    answer: "Si vous êtes deux, il y a moyen de réserver deux sièges en même temps dans la même voiture, pour autant qu'il y ait suffisamment de places. Dans le cas contraire, vous devrez faire des demandes dans deux voitures différentes."
  },
];

function Faq() {
  const { t } = useContext(LanguageContext)
  
  const [expanded, setExpanded] = useState(false);

  const handleChange = (panel) => (event, isExpanded) => {
    setExpanded(isExpanded ? panel : false);
  };

  return (
    <div className='my-6 content-parent'>
      <h3 className='text-4xl font-semibold mb-20 my-profile-title'>{t("faq.title")}</h3>

      {faqData.map((faq, index) => (
        <Accordion
          key={`panel${index + 1}`}
          expanded={expanded === `panel${index + 1}`}
          onChange={handleChange(`panel${index + 1}`)}
        >
          <AccordionSummary
            expanded={expanded === `panel${index + 1}`}
            aria-controls={`panel${index + 1}d-content`}
            id={`panel${index + 1}d-header`}
          >
            {faq.question}
          </AccordionSummary>
          <AccordionDetails>
            {faq.answer}
          </AccordionDetails>
        </Accordion>
      ))}
    </div>
  )
}

export default Faq
